"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _UIPopover = _interopRequireDefault(require("UIComponents/tooltip/UIPopover"));

var _EventBoundary = _interopRequireDefault(require("./EventBoundary"));

var _default = (0, _EventBoundary.default)(_UIPopover.default);

exports.default = _default;
module.exports = exports.default;